// here we put all modules
// that should be injected to all other angular modules
// beside puting your file here, you need to add module name to @Module decorator
import './directives/autofocus';
import './directives/loading';
import './directives/nodata';
import './directives/loading.app';
import './directives/check.browser';
import './directives/select.on.click';
import './directives/ui.select.helpers';
import './directives/read_only_icon';
import './helpers';
import './services/modals.registry';

export default class C {}



// WEBPACK FOOTER //
// ./src/app/defaults.js